import React from 'react'
import { css } from '@linaria/core'
import { PlaceWorld } from '@fs/zion-icon'
import LangPicker from '@fs/zion-lang-picker'
import { availableLangs, i18n } from '@fs/zion-locale'
import { Link } from '@fs/zion-router'
import { colors, Grid, Row, useOverlay } from '@fs/zion-ui'
import { Logo } from '../shared/components/FSLogo/FSLogo'

const CORE_LANGUAGES = ['en', 'es']

const headingCss = css`
  align-items: center;
  border-bottom: 1px solid ${colors.gray10};
  display: flex;
  height: 62px;
  padding: 0 16px;

  button {
    align-items: center;
    background: none;
    border: none;
    color: inherit;
    cursor: pointer;
    display: flex;
    font-size: 14px;
    padding: 0;
  }
  .button-text {
    margin-inline-start: 4px;
  }
`

function FSLogo() {
  return (
    <div style={{ height: 33.8, overflowY: 'hidden', width: 132 }}>
      <Link to={`https://cf.familysearch.org/${i18n.language}/cfprgm/service/link/home`} wayfinding external>
        <Logo />
      </Link>
    </div>
  )
}

function getLanguageText(code) {
  const language =
    availableLangs.core.find((lang) => lang.code === code) ||
    availableLangs.additional.find((lang) => lang.code === code)
  return language?.text || 'Unknown'
}

export default function CFHeader() {
  const langPickerOverlay = useOverlay()
  const language = getLanguageText(i18n.language)

  return (
    <div className={headingCss}>
      <Grid alignY="middle" growY guttersX="xxs" guttersY="xs">
        <FSLogo columns={6} />
        <Row columns={6} alignX="end">
          <button onClick={langPickerOverlay.handleClick} type="button">
            <PlaceWorld />
            <span className="button-text">{language}</span>
          </button>
        </Row>
      </Grid>
      <LangPicker overlay={langPickerOverlay} coreLangs={CORE_LANGUAGES} additionalLangs={[]} />
    </div>
  )
}
